import './Footer.css'

const Footer = () => (
  <footer className='footer'>
    {/* <a
      href='https://github.com/mvanzo'
      className='link footer__link'
    >
      Created By Marty Vanzo
    </a> */}
    <p>Created by Marty Vanzo</p>
  </footer>
)

export default Footer
